import {
  VALID_MINI_YOUTUBE_HOST_NAMES,
  VALID_YOUTUBE_HOST_NAMES
} from "@seneca/user-quiz-service-consts";

import { validatePassword } from "seneca-common/utils/functions/validation/password";
import {
  validateEmailLoosely,
  validateEmailStrictly,
  validatePhoneNumberLoosely,
  validateUrl
} from "seneca-common/utils/functions/validationFunctions";

import { Option } from "../inputs/common";
import { SchoolControlledOptionValue } from "./fetchSchoolControlledDropdownOptions";

export const requireText = (value: string) => {
  if (value.length < 1) return "Please enter a value";
  return true;
};

export const requireDropdown = (value: any) => {
  if (
    typeof value === "undefined" ||
    value === null ||
    value.length === 0 ||
    value.value?.length === 0
  )
    return "Please select an option";
  return true;
};

export const requireCheckboxChecked =
  (errorMessage: string) => (value: boolean) => {
    return value ? true : errorMessage;
  };

export const requireSchoolDropdown = (
  value: Option<SchoolControlledOptionValue>
) => {
  if (value?.value?.name?.length > 0) return true;
  return "Please select an option";
};

export const validateControlledPhoneNumber = (phoneNumber: string) => {
  const err = validatePhoneNumberLoosely(phoneNumber);
  return err ? err : true;
};

export const validateControlledEmailLoosely = (email: string) => {
  const err = validateEmailLoosely(email);
  return err ? err : true;
};

export const validateControlledEmailStrictly = (email: string) => {
  const err = validateEmailStrictly(email);
  return err ? err : true;
};

export const validateControlledUrl = (url: string) => {
  const err = validateUrl(url);
  return err ? err : true;
};

export const validateControlledPassword = (password: string) => {
  const err = validatePassword(password);
  return err ? err : true;
};

export const validateCharacterLimit = (low: number, high: number) => {
  return function (value: string) {
    if (value.length < low) return `Minimum ${low} characters`;
    if (value.length > high) return `Maximum ${high} characters`;
    return true;
  };
};

const YOUTUBE_VALIDATION_ERROR_MESSAGE =
  "Please input a valid YouTube link (e.g. https://www.youtube.com/watch?v=rAJGnS_ktk4).";

export const validateYoutubeUrl = (resourceUrl: string) => {
  function isYouTubeVideoURL(url: URL) {
    return (
      VALID_YOUTUBE_HOST_NAMES.includes(url.hostname) &&
      url.searchParams.has("v")
    );
  }

  function isYouTubeMiniURL(url: URL) {
    return VALID_MINI_YOUTUBE_HOST_NAMES.includes(url.hostname);
  }
  try {
    const url = new URL(resourceUrl);

    return (
      isYouTubeVideoURL(url) ||
      isYouTubeMiniURL(url) ||
      YOUTUBE_VALIDATION_ERROR_MESSAGE
    );
  } catch (error) {
    return YOUTUBE_VALIDATION_ERROR_MESSAGE;
  }
};
